import React, { Component } from 'react';
// import FetchCall from '../../API/FetchCall';
import { getInvoiceInfo } from '../../../../API/FetchCall';
import PdfContainer from './PdfContainer';
import Doc from './DocService';

//npm i @progress/kendo-react-pdf@3.5.1-dev.201910161723

//npm i @progress/kendo-drawing

class PlayAreaCompare extends Component {

  constructor(props) {
    super(props);
    console.log('this.props', this.props);
    this.state = {
      compareData: this.props.viewData.compareData,
      ratingData: this.props.viewData.ratingData,
      date: this.props.viewData.date
    };
  }
  componentDidMount() {

  }
  createPdf = (html) => Doc.createPdf(html);


  render() {
    const { compareData, ratingData } = this.state;
    console.log('this.state.compareData re', compareData)
    let dataLen = compareData.length;
    let scl = dataLen > 0 ? compareData[0].name : '';
    return (

      <React.Fragment>
        <div class="row">
            <div class="hdr-logo-pdf"><img src="/assets/bewiseLogo.png" width="100%" /></div>
        </div>
        <div className="row invoice-container compare-container">
          <div className="back-drop">
            <h2>{`Confidential - Bewise prepared for ${scl.trim()}`}</h2>
            <div id="watermark"><img src="/assets/bewiseLogo.png" width="100%" /></div>
          </div>
          <div className='row'>
            <p>Date : {this.state.date}</p>
            <table className='table table-bordered comparetable'>
              <tr>
                <th>Name</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.name}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Sub Categories</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.sub_categories}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>No of Trainees</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.no_teacher ? item.no_teacher : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Facilites</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.facilites}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Timing</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.from_time.includes('NA') || item.to_time.includes('NA') ? 'NA' : `${item.from_time} - ${item.to_time}`}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Established Year</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.est_year ? item.est_year : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Minimal Entry Fee</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.entry_fee == 0 || item.entry_fee == 'NA' ? 'NA' : (<span>&#8377; {item.entry_fee}</span>)}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th colSpan={1 + compareData.length}>Rating</th>
              </tr>
              <tr>
                <th>Covid19 Responses</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.covid19}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Quality of Staff</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.qty_staff}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Cleanliness</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.cleanliness}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Child Safety</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.child_safety}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Child Safety</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.child_safety}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Facilities for parents</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.facilities_parent}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Food Quality</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.food}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Crowd size</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.crowd_size}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Overall Rating</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.overall_expirence}</td>
                  )
                })}
              </tr>
            </table>
          </div>
        </div>
      </React.Fragment>

    );
  }
}

export default PlayAreaCompare;



// WEBPACK FOOTER //
// ./src/components/bewise/partners/benchmark/playarea_compare.jsx